import React, { FC } from "react";
import { graphql, Link as GatsbyLink, useStaticQuery } from "gatsby";
import { formatDistanceToNow } from "date-fns";
import Text, { TextSize, TextTone } from "../Text";
import { Button, ButtonSize, ButtonType } from "kaleidoscope";
import { handleMouseUpByBlurring } from "kaleidoscope/src/utils/focus";
import { ArrowLeft, ArrowRight } from "kaleidoscope/src/global/icons";
import classNames from "classnames";

interface FooterLink {
  url: string;
  title: string;
}

interface FooterProps {
  prevPost?: FooterLink;
  nextPost?: FooterLink;
  modified: string;
  className?: string;
}

const Footer: FC<FooterProps> = ({ prevPost, nextPost, modified, className }) => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      metadataYaml {
        contact
      }
    }
  `);

  return (
    <footer className={classNames("kld-footer", className)}>
      {!prevPost && !!nextPost && (
        <GatsbyLink className="kld-footer__link kld-footer__link--prev" to="/" onMouseUp={handleMouseUpByBlurring}>
          <Text tone={TextTone.Secondary}>Previous</Text>
          <Text className="kld-footer__link-title" size={TextSize.XXLarge}>
            <ArrowLeft className="kld-footer__link-icon" />
            <Text truncate size={TextSize.Auto}>
              API Docs Home
            </Text>
          </Text>
        </GatsbyLink>
      )}
      {!!prevPost && (
        <GatsbyLink
          className="kld-footer__link kld-footer__link--prev"
          to={prevPost.url}
          onMouseUp={handleMouseUpByBlurring}
        >
          <Text tone={TextTone.Secondary}>Previous</Text>
          <Text className="kld-footer__link-title" size={TextSize.XXLarge}>
            <ArrowLeft className="kld-footer__link-icon" />
            <Text truncate size={TextSize.Auto}>
              {prevPost.title}
            </Text>
          </Text>
        </GatsbyLink>
      )}
      {!!nextPost && (
        <GatsbyLink
          className="kld-footer__link kld-footer__link--next"
          to={nextPost.url}
          onMouseUp={handleMouseUpByBlurring}
        >
          <Text tone={TextTone.Secondary}>Next</Text>
          <Text className="kld-footer__link-title" size={TextSize.XXLarge}>
            <Text truncate size={TextSize.Auto}>
              {nextPost.title}
            </Text>
            <ArrowRight className="kld-footer__link-icon" />
          </Text>
        </GatsbyLink>
      )}
      <div className="kld-footer__meta">
        <div className="kld-footer__meta-item">
          <Text tone={TextTone.Secondary}>Last updated {formatDistanceToNow(new Date(modified))} ago</Text>
        </div>
        <div className="kld-footer__meta-item">
          <Text>Questions?</Text>
          <Button
            type={ButtonType.Secondary}
            size={ButtonSize.Small}
            href={() => `mailto:${data.metadataYaml.contact}`}
          >
            Contact us
          </Button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
